/* eslint-disable max-len */
export const emailRegEx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
export const cellPhoneRegEx = /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/

// Digit-only (unmasked) Brazilian phone formats.
// Mobile: DDD + 9 + 8 digits → ##9######## (11 digits, third digit is 9).
export const mobilePhoneRegEx = /^\d{2}9\d{8}$/
